type Positionable = { position: number }

export class UnableToCalculateNewPositionException extends Error {}

export default function calculateNewPosition<T extends Positionable>(
  oldIndex: number,
  newIndex: number,
  list: T[]
): number {
  let itemBefore: T | null = null
  let itemAfter: T | null = null
  if (newIndex === 0) {
    itemAfter = list[0] ?? null
  } else if (newIndex === list.length - 1) {
    itemBefore = list[list.length - 1] ?? null
  } else {
    itemBefore = list[newIndex > oldIndex ? newIndex : newIndex - 1] ?? null
    itemAfter = list[newIndex > oldIndex ? newIndex + 1 : newIndex] ?? null
  }
  let position: number | undefined
  if (itemBefore !== null && itemAfter !== null) {
    position = (itemBefore.position + itemAfter.position) / 2
  } else if (itemBefore === null && itemAfter !== null) {
    position = itemAfter.position / 2
  } else if (itemAfter === null && itemBefore !== null) {
    position = itemBefore.position + 1
  }
  if (position === undefined) {
    throw new UnableToCalculateNewPositionException()
  }
  return position
}
